import Phaser from "phaser";
import { COLORS, hexToPhaser } from "./colors";

export class PortalSpinner {
  private scene: Phaser.Scene;
  private container: Phaser.GameObjects.Container;
  private spinner: Phaser.GameObjects.Sprite;
  private spinnerTween: Phaser.Tweens.Tween | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;

    // Create main container
    this.container = scene.add.container(0, 0);
    this.container.setScrollFactor(0);
    this.container.setDepth(100003);

    // Create semi-transparent overlay background
    const overlay = scene.add.graphics();
    overlay.fillStyle(hexToPhaser(COLORS.BLACK), 0.5);
    overlay.fillRect(0, 0, scene.scale.width, scene.scale.height);
    overlay.setScrollFactor(0);
    this.container.add(overlay);

    // Create portal spinner sprite, 4x smaller and centered
    this.spinner = scene.add.sprite(
      scene.scale.width / 2,
      scene.scale.height / 2,
      "logo-portal"
    );
    this.spinner.setScrollFactor(0);
    this.spinner.setScale(0.25); // 4x smaller
    this.container.add(this.spinner);

    // Start rotating animation
    this.startRotation();
  }

  private startRotation(): void {
    // Kill any existing tween
    if (this.spinnerTween) {
      this.spinnerTween.stop();
    }

    // Create continuous rotation tween
    this.spinnerTween = this.scene.tweens.add({
      targets: this.spinner,
      rotation: Math.PI * 2,
      duration: 2000, // 2 seconds for a full rotation
      ease: "Linear",
      repeat: -1, // Loop infinitely
      onStart: () => {
        this.spinner.setRotation(0); // Reset rotation before starting
      },
    });
  }

  show(): void {
    this.container.setVisible(true);
  }

  hide(): void {
    this.container.setVisible(false);
  }

  destroy(): void {
    if (this.spinnerTween) {
      this.spinnerTween.stop();
      this.spinnerTween = null;
    }
    this.container.destroy();
  }
}
